<div class="d-flex flex-column align-items-center justify-content-center text-center {{paddings}}">
    <div class="h5 mb-3" *ngIf="text">{{text}}</div>
    <a class="contact-us-btn" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" title="contact">
        <i class="fas fa-envelope"></i>
        {{'Nous contacter' | translate}}
    </a>
</div>
